// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pelesrespyoffsavgdpc.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBlbGVzcmVzcHlvZmZzYXZnZHBjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA0NjQ2NzgsImV4cCI6MjA2NjA0MDY3OH0.f70NqRue-qiuIwg83d7VrKpkAU4Z8BZLYezM4x_Ywdo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);